<template lang="pug">
  section.error_404.content-body
    .p-3
      .row.flex-grow.mx-auto
        .col-lg-12.text-center
          h2 很抱歉!
          h3.font-weight-light 您訪問的頁面不存在.
</template>

<script>
export default {
  name: 'error404'
};
</script>

<style scoped lang="scss">
  .error_404 {
    cursor: default;
  }
</style>
